import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../api/client';

export interface UserSummary {
  id: number;
  cognito_id: string;
  email: string | null;
  first_name: string | null;
  last_name: string | null;
  phone_number: string | null;
  subscription_level: string;
  marketing_consent: boolean;
  weekly_tips_subscribed: boolean;
  marketing_consent_date: string | null;
  created_at: string;
  updated_at: string;
}

export function useUsers() {
  return useQuery({
    queryKey: ['users'],
    queryFn: () => apiClient<UserSummary[]>('/users'),
  });
}

export function useUserDetail(userId: string) {
  return useQuery({
    queryKey: ['user', userId],
    queryFn: () => apiClient<UserSummary>(`/users/${userId}`),
  });
}
